import * as React from 'react';
import { connect } from 'react-redux';
import { isNil } from 'lodash';

import { TableCell, TableRow } from 'components/table';
import CampaignsTableActionsCell from './CampaignsTableActionsCell';
import CampaignsTableBrandCell from './CampaignsTableBrandCell';
import CampaignsTableInfluencerBudgetCell from './CampaignsTableInfluencerBudgetCell';
import CampaignsTableBrandBudgetCell from './CampaignsTableBrandBudgetCell';
import CampaignsTableCreatorsCell from './CampaignsTableCreatorsCell';
import CampaignsTableCampaignCell from './CampaignsTableCampaignCell';
import CampaignsTableDateCell from './CampaignsTableDateCell';
import SubcampaignBanners from './subcampaign-banners/SubcampaignBanners';

import { ORGANIZATION_PROFILE_TYPE_BRAND, ORGANIZATION_PROFILE_TYPE_INFLUENCER } from 'utils/organization';

import './campaigns-table-row-influencer.scss';

import type {
  ApprovalStatus,
  CampaignOverview,
  CampaignWithSubcampaignMeta,
  DeliverablesOverdueBySubcampaignIdLocal,
  OrganizationProfileType
} from 'types';

type StateProps = {
  overview: CampaignOverview | undefined | null
};

type OwnProps = {
  disabled?: boolean,
  campaign: CampaignWithSubcampaignMeta,
  profileType: OrganizationProfileType,
  overdueDeliverables?: DeliverablesOverdueBySubcampaignIdLocal,
  influencerStatus?: ApprovalStatus
};

type Props = StateProps & OwnProps;

class CampaignsTableRow extends React.PureComponent<Props> {
  renderInfluencerRow = () => {
    const { campaign, overdueDeliverables, influencerStatus } = this.props;
    const hasCampaignLink = influencerStatus === 'approved' || influencerStatus === 'rejected';

    return (
      <div className="campaigns-table-row-influencer">
        <TableRow
          nowrap
          align="top"
        >
          <TableCell width="tiny" overflow="hidden">
            <CampaignsTableBrandCell
              brandProfile={campaign.brandProfile}
              brandProfileId={campaign.brandProfileId}
            />
          </TableCell>
          <TableCell width="bigger" overflow="hidden">
            <CampaignsTableCampaignCell
              campaign={campaign}
              overview={null}
              data={{ qa: 'campaigns-table-campaign-cell-title' }}
              hasCampaignLink={hasCampaignLink}
            />
          </TableCell>

          <TableCell
            width="232px"
          >
            <CampaignsTableDateCell campaign={campaign} />
          </TableCell>

          <TableCell
            width="270px"
          >
            <CampaignsTableInfluencerBudgetCell
              campaign={campaign}
            />
          </TableCell>

          <TableCell width="fill">
            <CampaignsTableActionsCell
              campaign={campaign}
              profileType={ORGANIZATION_PROFILE_TYPE_INFLUENCER}
              overview={null}
              hasCampaignLinks={influencerStatus !== 'pending'}
              hideMessengerLink={influencerStatus !== 'approved'}
            >
              {!isNil(campaign.subcampaignMeta) && (
                <SubcampaignBanners
                  hasCampaignLinks={influencerStatus !== 'pending'}
                  overdueDeliverables={overdueDeliverables}
                  campaign={campaign}
                  subcampaign={campaign.subcampaignMeta}
                />
              )}
            </CampaignsTableActionsCell>
          </TableCell>
        </TableRow>
      </div>
    );
  };

  renderBrandRow = () => {
    const { campaign, overview, disabled } = this.props;

    return (
      <TableRow nowrap disabled={disabled}>
        <TableCell width="tiny" overflow="hidden">
          <CampaignsTableBrandCell
            brandProfile={campaign.brandProfile}
            brandProfileId={campaign.brandProfileId}
          />
        </TableCell>
        <TableCell width="fill" overflow="hidden">
          <CampaignsTableCampaignCell
            campaign={campaign}
            overview={overview}
            data={{ qa: 'campaigns-table-campaign-cell-title' }}
            hasCampaignLink
          />
        </TableCell>

        <TableCell width="120px" verticalAlign="start">
          <CampaignsTableCreatorsCell
            overview={overview}
          />
        </TableCell>

        <TableCell width="214px" verticalAlign="start">
          <CampaignsTableBrandBudgetCell
            campaign={campaign}
            overview={overview}
          />
        </TableCell>

        <TableCell width="270px">
          <CampaignsTableActionsCell
            campaign={campaign}
            profileType={ORGANIZATION_PROFILE_TYPE_BRAND}
            overview={overview}
            hasCampaignLinks
          />
        </TableCell>
      </TableRow>
    );
  };

  render() {
    const { profileType } = this.props;

    if (profileType === ORGANIZATION_PROFILE_TYPE_INFLUENCER) {
      return this.renderInfluencerRow();
    }

    if (profileType === ORGANIZATION_PROFILE_TYPE_BRAND) {
      return this.renderBrandRow();
    }

    return null;
  }
}

const mapStateToProps = ({ brandCampaigns }, { campaign, profileType }): StateProps => ({
  overview: profileType === ORGANIZATION_PROFILE_TYPE_BRAND ?
    brandCampaigns.overviewsByCampaignId[campaign.id] :
    null
});

export default connect(mapStateToProps)(CampaignsTableRow);
